import { Container, Spinner, Text, VStack } from '@chakra-ui/react';

export function Loading(props: { text?: string }) {
	return (
		<Container maxW="container.md" py={10}>
			<VStack gap={4} align="center">
				<Spinner size="xl" />
				<Text>{props.text ?? 'Loading'}...</Text>
			</VStack>
		</Container>
	);
}
